import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type CarReservationCreateMutationVariables = Types.Exact<{
  payload: Types.CarReservationCreatePayload;
}>;

export type CarReservationCreateMutation = {
  __typename?: 'Mutation';
  carReservationCreate: {
    __typename?: 'CarReservationCreateResult';
    checkoutMode: Types.CarCheckoutModeDtoEnum;
    paymentIntentClientSecret?: string | null;
    reservation: { __typename?: 'CarReservationDto'; id: string; status: Types.CarReservationStatusDtoEnum };
  };
};

export const CarReservationCreateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CarReservationCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CarReservationCreatePayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carReservationCreate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'checkoutMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paymentIntentClientSecret' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reservation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CarReservationCreateMutationFn = Apollo.MutationFunction<CarReservationCreateMutation, CarReservationCreateMutationVariables>;

/**
 * __useCarReservationCreateMutation__
 *
 * To run a mutation, you first call `useCarReservationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarReservationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carReservationCreateMutation, { data, loading, error }] = useCarReservationCreateMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCarReservationCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CarReservationCreateMutation, CarReservationCreateMutationVariables>) {
  return ApolloReactHooks.useMutation<CarReservationCreateMutation, CarReservationCreateMutationVariables>(CarReservationCreateDocument, baseOptions);
}
export type CarReservationCreateMutationHookResult = ReturnType<typeof useCarReservationCreateMutation>;
export type CarReservationCreateMutationResult = Apollo.MutationResult<CarReservationCreateMutation>;
export type CarReservationCreateMutationOptions = Apollo.BaseMutationOptions<CarReservationCreateMutation, CarReservationCreateMutationVariables>;
